module.exports = __webpack_public_path__ + "static/media/logo_netpg.404aaf1b.svg";